<template>
  <div>
    <div class="question-tab" v-if="type == 'tractor'">
      <div class="button-div">
        <button
          v-for="(tractor, i) in tractors"
          :key="i"
          @click="handleClick(tractor)"
          :class="clicked.includes(tractor) ? 'green-btn' : 'default-btn'"
        >
          {{ tractor }}
        </button>
      </div>
    </div>
    <div class="question-tab" v-if="type == 'cattle'">
      <div class="button-div">
        <button
          v-for="(cattle, i) in cattles"
          :key="i"
          @click="handleCattleClick(cattle.id)"
          :class="
            CattleClicked.includes(cattle.id) ? 'green-btn' : 'default-btn'
          "
        >
          {{ cattle.eng_title }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import API_URL from "../../../../helpers/apiUrls";
export default {
  name: "ownershipMultipleButton",
  data() {
    return {
      clicked: [],
      tractors: [],
      CattleClicked: [],
      cattles: [],
    };
  },
  props: {
    type: String,
  },
  mounted() {
    console.log(this.data);
  },
  created() {
    if (this.type == "tractor") {
      this.getTractorList();
    }
    if (this.type == "cattle") {
      this.getCattlesList();
    }
    const data = this.$store.getters["crmFilters/GET_OWNERSHIP_DATA"];
    this.clicked = data.ownership.tractor.tractor_brand;
    this.CattleClicked = data.ownership.cattle.animal_interest;
  },
  methods: {
    setDataToStore(ownership) {
      this.$store.dispatch("crmFilters/setOwnership", { ownership });
    },
    handleClick(val) {
      const payload = this.$store.getters["crmFilters/GET_OWNERSHIP_DATA"];
      if (!this.clicked.includes(val)) {
        this.clicked.push(val);
      } else {
        const index = this.clicked.indexOf(val);
        if (index > -1) {
          this.clicked.splice(index, 1);
        }
      }
      console.log(this.clicked);
      payload.ownership.tractor.tractor_brand = this.clicked;
      console.log(payload);
      this.setDataToStore(payload.ownership);
    },
    handleCattleClick(val) {
      const payload = this.$store.getters["crmFilters/GET_OWNERSHIP_DATA"];
      if (!this.CattleClicked.includes(val)) {
        this.CattleClicked.push(val);
      } else {
        const index = this.CattleClicked.indexOf(val);
        if (index > -1) {
          this.CattleClicked.splice(index, 1);
        }
      }
      console.log(this.CattleClicked, payload);
      payload.ownership.cattle.animal_interest = this.CattleClicked;
      this.setDataToStore(payload.ownership);
    },
    getTractorList() {
      const successHandler = (response) => {
        if (response.status === 200) {
          this.tractors = response.data.tractor_list;
        }
      };

      const errorHandler = (response) => {
        this.showToast("Something went wrong internally!", "error", 10000);
      };

      this.requestGET(
        `${API_URL.tractors}`,
        {},
        {},
        successHandler,
        errorHandler,
        process.env.VUE_APP_API_BASE_URL_DISCOVERY,
        30000
      );
    },
    getCattlesList() {
      const successHandler = (response) => {
        if (response.status === 200) {
          this.cattles = response.data;
        }
      };

      const errorHandler = (response) => {
        this.showToast("Something went wrong internally!", "error", 10000);
      };

      this.requestGET(
        `${API_URL.animals}`,
        {},
        {},
        successHandler,
        errorHandler,
        process.env.VUE_APP_API_BASE_URL_DISCOVERY,
        30000
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.question-tab {
  display: flex;
  flex-direction: column;
  margin-left: 28px;
  // margin-top:28px;
  //row-gap: 24px;
  overflow-y: scroll;
  p {
    margin: 0;
  }
}
.button-div {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  height: 100px;
}
.default-btn {
  height: 35px;
  width: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #efefef;
  color: #4b4b4b;
  padding: 8px 12px;
  border-radius: 4px;
}
.green-btn {
  height: 35px;
  width: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #efefef;
  color: #189d3b;
  background: #f3faf5;
  padding: 8px 12px;
  border-radius: 4px;
}
</style>
